"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductAllOfToJSON = exports.ProductAllOfFromJSONTyped = exports.ProductAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ProductAllOfFromJSON(json) {
    return ProductAllOfFromJSONTyped(json, false);
}
exports.ProductAllOfFromJSON = ProductAllOfFromJSON;
function ProductAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'orderNumber': !(0, runtime_1.exists)(json, 'orderNumber') ? undefined : json['orderNumber'],
        'promotion': !(0, runtime_1.exists)(json, 'promotion') ? undefined : json['promotion'],
        'size': !(0, runtime_1.exists)(json, 'size') ? undefined : json['size'],
        'paymentMethod': json['paymentMethod'],
        'installmentCount': !(0, runtime_1.exists)(json, 'installmentCount') ? undefined : json['installmentCount'],
        'isReturned': json['isReturned'],
        'isNali': json['isNali'],
        'priceModifications': !(0, runtime_1.exists)(json, 'priceModifications') ? undefined : (json['priceModifications'].map(_1.PriceModificationFromJSON)),
        'finalPrice': (0, _1.AmountFromJSON)(json['finalPrice']),
        'aplus': !(0, runtime_1.exists)(json, 'aplus') ? undefined : (json['aplus'].map(_1.ProductAllOfAplusFromJSON)),
    };
}
exports.ProductAllOfFromJSONTyped = ProductAllOfFromJSONTyped;
function ProductAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'orderNumber': value.orderNumber,
        'promotion': value.promotion,
        'size': value.size,
        'paymentMethod': value.paymentMethod,
        'installmentCount': value.installmentCount,
        'isReturned': value.isReturned,
        'isNali': value.isNali,
        'priceModifications': value.priceModifications === undefined ? undefined : (value.priceModifications.map(_1.PriceModificationToJSON)),
        'finalPrice': (0, _1.AmountToJSON)(value.finalPrice),
        'aplus': value.aplus === undefined ? undefined : (value.aplus.map(_1.ProductAllOfAplusToJSON)),
    };
}
exports.ProductAllOfToJSON = ProductAllOfToJSON;
//# sourceMappingURL=ProductAllOf.js.map